import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    TextField,
    Button,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    IconButton,
    Chip,
    Autocomplete,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Tooltip,
    Modal,
    Collapse,
    Divider,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    Paper,
    DialogActions
} from "@mui/material";
import { Edit, Delete, CheckCircle } from "@mui/icons-material";
import { CommonEditButton, CommonPatientDetails, OpenWebCamPopUP, ShowBase64Document } from "../../../Components/Common Components/CommonComponents";
import { getCachevalue, localGetItem } from "../../../Utility/Services/CacheProviderService";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Colors } from "../../../Styles/Colors";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { ImagePaths } from "../../../Utility/ImagePaths";
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import { AmountFormat, ContentInTooltip, dataURItoFile, formatDate } from "../../../Components/CommonFunctions/CommonFunctions";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { DateTime } from "luxon";
import CancelIcon from '@mui/icons-material/Cancel';
import Loader from '../../../Components/Loader'
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";

export default function DocRadiotherapy({ forDocApproval, FromDosimetrist, forDocAdd, ...props }) {

    const history = useHistory();
    const location = useLocation();
    const uploadImage = useRef(null);

    const [PatientData, setPatientData] = useState(null);
    const [TherapyMaster, setTherapyMaster] = useState([]);
    const [TherapyTecniques, setTherapyTecniques] = useState([]);
    const [TherapyRegions, setTherapyRegions] = useState([]);
    const [TherapyTag, setTherapyTag] = useState([]);
    const [TherapyImmuzationDevice, setTherapyImmuzationDevice] = useState([]);
    const [TherapyMachines, setTherapyMachines] = useState([]);

    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');

    const [therapyDetails, setTherapyDetails] = useState([]);
    const [packageDetails, setPackageDetails] = useState([]);

    const [maxDocDiscount, setMaxDocDiscount] = useState(0);
    const [expandedRow, setExpandedRow] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [accordionOpen, setAccordionOpen] = useState(false);
    const [radioTherapyId, setRadiotherapyId] = useState(null);
    const [therapyPatientDetails, settherapyPatientDetails] = useState(null);
    const [editSession, setEditSession] = useState(null);
    const [editSessionCfPop, setEditSessioncfPop] = useState(null);
    const [cancelTherapy, setCancelTherapy] = useState(null);
    const [cancelTherapyId, setCancelTherapyId] = useState(null);
    const [approverList, setApproverList] = useState(null);
    const [selectedApprover, setSelectedApprover] = useState(null);

    const [formState, setFormState] = useState({
        therapy: null,
        technique: null,
        package: null,
        radiationType: "",
        treatmentRegion: null,
        immobilizationDevice: null,
        startDate: null,
        totalDose: "",
        fractions: "",
        frequency: "",
        dosePerFraction: "",
        fieldName: "",
        fieldSize: "",
        separation: "",
        depth: "",
        patientPosition: "",
        machine: null,
        nextReviewDate: null,
        rtTag: null,
        dosimetristNotes: "",
        DoctorNotes: "",
        TherapyStatus: "",
        discountPercentage: "",
        discountAmount: "",
        discountComments: "",
        BillingDetails: null,

    });

    const [Attachment, setAttachment] = useState(
        {
            open: false,
            imageuploadList: [],
            imageViewerPopup: false,
            viewData: [],
            viewImage: null,
            selectedImage: null,
            imgCapClked: false,
            CapturedImg: null,
            currentIndex: 0,
        }
    );

    useEffect(() => {
        let PatientDatas = getCachevalue('IppatientData')
            ? JSON.parse(getCachevalue('IppatientData'))
            : getCachevalue('patientData')
                ? JSON.parse(getCachevalue('patientData'))
                : JSON.parse(getCachevalue('DoctorPatientData'));

        setPatientData(PatientDatas);


        if (forDocAdd) {
            GetTherapyDetails(PatientDatas?.patient_id);
            getApporverListData()
        }
        if (FromDosimetrist || forDocApproval) {
            GetDosimetrist()
        } else {
            GetTherapyMasters();
            GetTherapyTechnics();
            GetTherapyRegions();
            GetImmuDevices();
            GetTherapyMachines();
            GetTherapyTags();
        }
    }, []);


    useEffect(() => {
        if (!formState?.package) {
            setFormState((prev) => ({
                ...prev,
                discountAmount: "",
                discountPercentage: "",
                discountComments: ""
            }))
        }
    }, [formState?.package])

    const errorMessage = (msg) => {
        seterrorMsgText(msg);
        seterrorMsg(true);
        setisloader(false)

    };

    const successMessage = (msg) => {
        setsuccessMsgText(msg);
        setsuccessMsg(true);
        setisloader(false)

    };

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    };

    const GetTherapyTechnics = (ID = null) => {
        RestAPIService.getAll(Serviceurls.TREATMENT_TECHNIQUE_GET)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyTecniques(response.data.data || []);
                    if (ID) {
                        setFormState((prev) => ({ ...prev, technique: response.data.data?.find((item) => (item?.id === ID)) }));
                    }
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetTherapyMasters = (ID = null) => {
        RestAPIService.getAll(Serviceurls.RADIO_THERAPY_GET)
            .then((response) => {
                if (response.data.status === 'success') {
                    if (ID) {
                        setTherapyMaster(response.data.data || []);
                        setFormState((prev) => ({ ...prev, therapy: response.data.data?.find((item) => (item?.id === ID)) }));
                    } else {
                        setTherapyMaster(response.data.data?.filter((list) => list?.is_active) || []);
                    }
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetTherapyRegions = (ID = null) => {
        RestAPIService.getAll(Serviceurls.TREATMENT_REGION_GET)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyRegions(response.data.data?.filter((list) => list?.is_active) || []);
                    if (ID) {
                        setFormState((prev) => ({ ...prev, treatmentRegion: response.data.data?.filter((list) => list?.is_active)?.find((item) => (item?.id === ID)) }));
                    }
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetTherapyTags = (ID = null) => {
        RestAPIService.getAll(Serviceurls.RADIOTHERAPY_TAG)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyTag(response.data.data?.filter((list) => list?.is_active) || []);
                    if (ID) {
                        setFormState((prev) => ({ ...prev, rtTag: response.data.data?.filter((list) => list?.is_active)?.find((item) => (item?.id === ID)) }));
                    }
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetImmuDevices = (ID = null) => {
        RestAPIService.getAll(Serviceurls.IMMOBILIZATION_DEVICE_GET)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyImmuzationDevice(response.data.data?.filter((list) => list?.is_active) || []);
                    if (ID) {
                        setFormState((prev) => ({ ...prev, immobilizationDevice: response.data.data?.filter((list) => list?.is_active)?.find((item) => (item?.id === ID)) }));
                    }
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetTherapyMachines = (ID = null) => {
        RestAPIService.getAll(Serviceurls.STIMULATOR_GET)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyMachines(response.data.data?.filter((list) => list?.is_active) || []);
                    if (ID) {
                        setFormState((prev) => ({ ...prev, machine: response.data.data?.filter((list) => list?.is_active)?.find((item) => (item?.id === ID)) }));
                    }
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetTherapyDetails = (patientid) => {
        setisloader(true)
        let LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let clinicID = LoggedUserData?.module_name === "Doctor" ? (localGetItem("SelectedDoctorClinicId") !== null ? `&clinic_id=${localGetItem("SelectedDoctorClinicId")}` : "") : ""
        RestAPIService.getAll(Serviceurls.RT_DOCTOR_TRANSMIT + `?patient_id=${patientid}${clinicID}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    setTherapyDetails(response.data.data || []);
                    setMaxDocDiscount(response.data.rt_discount_percentage || 0)
                    setisloader(false)
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const getApporverListData = () => {
        try {
            // let moduleType = loginInfo?.module_name === 'front_office' ? 'fo' : loginInfo?.module_name === 'Laboratory' ? 'lab' :
            //     loginInfo?.module_name === 'Radiology' ? 'radiology' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : ""
            RestAPIService.getAll(Serviceurls.NEW_BILLING_APPROVER_LIST + '?module=' + "fo")
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setApproverList(response?.data?.data)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const GetDosimetrist = () => {
        setisloader(true)
        RestAPIService.getAll(Serviceurls.RT_DOSIMETRIST_UPDATE + `?patient_radiotherapy_id=${location.states?.TherapyDetailId}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    let TherapyData = response?.data?.data[0] || null
                    settherapyPatientDetails(TherapyData)
                    setFormState((prev) => ({
                        ...prev,
                        radiationType: TherapyData?.radiation_type || "",
                        startDate: TherapyData?.start_date || null,
                        totalDose: TherapyData?.total_dose || "",
                        fractions: TherapyData?.number_of_fractions || "",
                        frequency: TherapyData?.treatment_frequency || "",
                        dosePerFraction: TherapyData?.dose_per_fraction || "",
                        fieldName: TherapyData?.field_name || "",
                        fieldSize: TherapyData?.field_size || "",
                        separation: TherapyData?.separation || "",
                        depth: TherapyData?.depth || "",
                        patientPosition: TherapyData?.patient_position || "",
                        nextReviewDate: TherapyData?.next_review_date || null,
                        dosimetristNotes: TherapyData?.dosimetrist_notes || null,
                        AddedDocuments: TherapyData?.dosimetrist_documents || null,
                        DoctorNotes: TherapyData?.doctor_notes || "",
                        BillingDetails: TherapyData?.billing_details || null,
                        discountAmount: TherapyData?.billing_details?.discount_amount || "",
                        discountPercentage: TherapyData?.billing_details?.discount_percentage || "",
                        discountComments: TherapyData?.billing_details?.discount_comments || "",
                    }));
                    GetTherapyMasters(TherapyData?.therapy_id);
                    GetTherapyTechnics(TherapyData?.technique_id);
                    GetTherapyRegions(TherapyData?.treatment_region_id);
                    GetImmuDevices(TherapyData?.immobilization_device_id);
                    GetTherapyMachines(TherapyData?.simulator_id);
                    GetTherapyTags(TherapyData?.rt_tag_id);
                    setisloader(false)
                    GetPackageDetails(TherapyData?.therapy_name, TherapyData?.tachnique_name, TherapyData?.package_id)
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const GetPackageDetails = (TherapyName, TechniqueName, PackageId) => {
        RestAPIService.getAll(Serviceurls.RT_PACKAGE_LIST + `?therapy_id=${encodeURIComponent(TherapyName)}&therapy_technic_id=${encodeURIComponent(TechniqueName)}`)
            .then((response) => {
                if (response.data.status === 'success') {
                    setPackageDetails(response.data.data || []);
                    if (PackageId) {
                        setFormState((prev) => ({
                            ...prev,
                            package: response.data.data?.find((item) => (item?.id === PackageId))
                        }))
                    }
                }
            }).catch((error) => errorMessage(error?.response?.data?.message || error.message));
    };

    const handleChange = (name, value) => {
        switch (name) {
            case "totalDose":
                if (CommonValidation.DecimalNumberTwo(value) || value === '') {
                    return setFormState((prev) => ({
                        ...prev,
                        [name]: value,
                        dosePerFraction: ((prev?.fractions && value) ? Math.ceil(+(+value / +prev?.fractions)) : 0)
                    }))
                }
                break;
            case "fractions":
                if (CommonValidation.numberOnly(value) || value === '') {
                    return setFormState((prev) => ({
                        ...prev,
                        [name]: value,
                        dosePerFraction: (prev?.totalDose && value)
                            ? (+prev?.totalDose / +value).toString().includes('.')
                                ? (+prev.totalDose / +value).toString().split('.')[0] + '.' + (+prev.totalDose / +value).toString().split('.')[1].slice(0, 2)
                                : (+prev.totalDose / +value).toString()
                            : 0
                    }))
                }
                break;
            default: setFormState((prev) => ({ ...prev, [name]: value }));
        };
        if ((name === "therapy" || name === "technique") && value) {
            let TherapyName = (name === "therapy" ? value?.therapy_name : formState?.therapy?.therapy_name)
            let TechiqueName = (name === "technique" ? value?.therapy_technique_name : formState?.technique?.therapy_technique_name)
            if (TherapyName && TechiqueName) {
                GetPackageDetails(TherapyName, TechiqueName)
            }
        }
    }

    const RenderTextField = ({ name, label, type = "text", options, getOptionLabel, disable = false, maxlength = null, value = null }) => {
        if (options) {
            return (
                <Autocomplete
                    size="small"
                    options={options}
                    disabled={disable || formState?.TherapyStatus === "Approved"}
                    value={formState[name] || null}
                    getOptionLabel={getOptionLabel || ((opt) => (typeof opt === "string" ? opt : ""))}
                    onChange={(event, newValue) => handleChange(name, newValue || "")}
                    renderInput={(params) => <TextField {...params} label={label} disabled={disable} />}
                />
            );
        }

        if (type === "date") {
            return (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={formState[name] ? formState[name] : null}
                        name={"datePicker"}
                        inputFormat='DD-MM-YYYY'
                        disabled={disable || formState?.TherapyStatus === "Approved"}
                        minDate={new Date()}
                        views={["year", "month", "day"]}
                        onChange={(newDate) => {
                            setFormState((prev) => ({ ...prev, [name]: newDate }));
                        }}
                        renderInput={(params) => <TextField
                            {...params}
                            label={label}
                            variant="outlined"
                            disabled={disable}
                            onKeyDown={(e) => e.preventDefault()}
                            size='small'
                            error={false}
                        />}
                    />
                </LocalizationProvider>
            )
        }

        return (
            <TextField
                size="small"
                label={label}
                type={type}
                name={name}
                disabled={disable || formState?.TherapyStatus === "Approved"}
                value={value ? value : formState[name] || ""}
                onChange={(e) => handleChange(name, e.target.value)}
                InputLabelProps={type === "date" ? { shrink: true } : {}}
                inputProps={{ maxLength: maxlength }}

            />
        );
    };

    const getS3Key = async (doc_key, id) => {
        try {
            const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));

            if (response.data.status === "success") {
                const Data = response.data;
                return {
                    data_url: Data.data
                };
            }
        } catch (e) {
            setisloader(false)
            errorMessage("Error fetching S3 URL")
        }
    }

    const renderImage = async (imageData, pdfData) => {
        let tempArr = [];

        if (imageData.length > 0) {
            for (let i = 0; i < imageData.length; i++) {
                let image = imageData[i]?.doc_key;
                if (image !== null) {
                    let doc_key = image;
                    let getData = await getS3Key(doc_key); // make sure this is a top-level async function
                    getData["type"] = image.split('.').pop() === "pdf" ? "pdf" : "image";
                    tempArr.push(getData);
                }
            }
        }

        setAttachment(prev => {
            const updated = {
                ...prev,
                viewData: tempArr,
                viewImage: tempArr[0]
            };

            // Do window.open *after* state is set
            if (pdfData) {
                setTimeout(() => {
                    if (updated.viewImage?.data_url) {
                        window.open(updated.viewImage.data_url);
                    }
                }, 0);
            }

            return updated;
        });
    };

    const onImageHandler = async (e) => {
        const imageList = [];
        let imageFiles = [...e.target.files];

        let clearedArr = imageFiles?.filter((image, i) => {
            let file = image?.name;
            return String(file).toLowerCase() !== String(imageFiles[i + 1]?.name).toLowerCase();
        });

        for (let i = 0; i < clearedArr.length; i++) {
            imageList.push(clearedArr[i]);
        }

        const newList = await Promise.all(imageList);

        setAttachment((prev) => ({
            ...prev,
            imageuploadList: [...prev.imageuploadList, ...newList],
        }));

        e.target.value = '';
    };

    const onImageRemove = (index) => {
        setAttachment((prev) => {
            const updatedList = [...prev.imageuploadList];
            updatedList.splice(index, 1);
            return {
                ...prev,
                imageuploadList: updatedList,
            };
        });
    };

    const prevImage = (index) => {
        let currentIndex = parseInt(index) || 0;

        if (currentIndex >= 1) {
            setAttachment((prev) => ({
                ...prev,
                currentIndex: currentIndex - 1,
                viewImage: prev.viewData[currentIndex - 1],
            }));
        }
    };

    const nextImage = (index) => {
        let currentIndex = parseInt(index) || 0;

        if (currentIndex + 1 < Attachment.viewData.length) {
            setAttachment((prev) => ({
                ...prev,
                currentIndex: currentIndex + 1,
                viewImage: prev.viewData[currentIndex + 1],
            }));
        }
    };

    const renderImageViewerPopup = () => {
        try {
            if (Attachment.viewData?.length > 0) {
                return (
                    <Box component={'div'}>
                        <Modal open={Attachment.imageViewerPopup}>
                            <Box className='eMed_Doc_Img_Pop_Up'>
                                <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'1vw'} alignItems={'center'} justifyContent={'space-between'}>
                                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                                        MRD Documents
                                    </Typography>
                                    <Button
                                        onClick={() =>
                                            setAttachment((prev) => ({
                                                ...prev,
                                                imageViewerPopup: false,
                                            }))
                                        }
                                    >
                                        <Box
                                            component={'img'}
                                            src={ImagePaths.LabCloseButton.default}
                                            height={'1vw'}
                                            width={'1vw'}
                                            mr={'1vw'}
                                        />
                                    </Button>
                                </Box>

                                <Box height={'30vw'} display={'flex'} justifyContent={'center'}>
                                    {Attachment.viewData?.length > 1 && (
                                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                                            <Button
                                                size="small"
                                                className="Common_Btn_Min_Width"
                                                sx={{ height: '3vw' }}
                                                onClick={() => prevImage(Attachment.currentIndex)}
                                            >
                                                <KeyboardDoubleArrowLeftIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" />
                                            </Button>
                                        </Box>
                                    )}

                                    {Attachment.viewImage?.type === 'pdf' ? (
                                        <Box sx={{ display: 'flex', flexDirection: 'column', padding: "3vw" }}>
                                            <img
                                                style={{ width: '12vw', height: '12vw' }}
                                                src={ImagePaths.DocumentPreview.default}
                                                alt="slide"
                                            />
                                            <Button variant="contained" onClick={() => window.open(Attachment.viewImage?.data_url)}>
                                                Download Document
                                            </Button>
                                        </Box>
                                    ) : (
                                        <Box component={'div'} height={'30vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                            <img
                                                src={Attachment.viewImage?.data_url || ''}
                                                alt="slide"
                                                style={{ objectFit: 'contain', height: '15vw', width: '30vw' }}
                                            />
                                        </Box>
                                    )}

                                    {Attachment.viewData?.length > 1 && (
                                        <Box component={'div'} display={'flex'} alignItems={'center'}>
                                            <Button
                                                size="small"
                                                className="Common_Btn_Min_Width"
                                                sx={{ height: '3vw' }}
                                                onClick={() => nextImage(Attachment.currentIndex)}
                                            >
                                                <KeyboardDoubleArrowRightIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" />
                                            </Button>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </Modal>
                    </Box>
                );
            }
            return null;
        } catch (error) {
            errorMessage(error?.message)
        }
    };

    const closeWebCamPop = () => {
        setAttachment((prev) => ({
            ...prev,
            imgCapClked: false,
            CapturedImg: null,
        }));
    };

    const addImgCapture = (data) => {
        if (data) {
            setAttachment((prev) => ({
                ...prev,
                imageuploadList: [
                    ...prev.imageuploadList,
                    dataURItoFile(data, `report_file_${Date.now()}.jpg`)
                ],
                imgCapClked: false,
            }));
        }
    };

    const clearFunction = () => {
        setFormState({
            therapy: null,
            technique: null,
            package: null,
            radiationType: "",
            treatmentRegion: null,
            immobilizationDevice: null,
            startDate: null,
            totalDose: "",
            fractions: "",
            frequency: "",
            dosePerFraction: "",
            fieldName: "",
            fieldSize: "",
            separation: "",
            depth: "",
            patientPosition: "",
            machine: null,
            nextReviewDate: null,
            rtTag: null,
            dosimetristNotes: "",
            DoctorNotes: "",
            TherapyStatus: "",
        })
        setRadiotherapyId(null)
        setSelectedApprover(null) 
    }

    const postTransmitDetails = (ForApproval = false) => {
        try {
            let LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))
            setisloader(true)
            let data = {
                'patient_id': PatientData?.patient_id || null,
                'appointment_id': PatientData?.appointment_id || null,
                'branch_id': localGetItem("BranchId"),
                'doctor_id': LoggedUserData?.doctor_id || null,
                'therapy_id': formState?.therapy?.id || null,
                'technique_id': formState?.technique?.id || null,
                'package_id': formState?.package?.id || null,
                'treatment_region_id': formState?.treatmentRegion?.id || null,
                'immobilization_device_id': formState?.immobilizationDevice?.id || null,
                'simulator_id': formState?.machine?.id || null,
                'radiation_type': formState?.radiationType || null,
                'start_date': formState?.startDate ? DateTime.fromJSDate(new Date(formState?.startDate)).toFormat('yyyy-MM-dd') : null,
                'total_dose': formState?.totalDose || 0,
                'number_of_fractions': formState?.fractions || 0,
                'dose_per_fraction': formState?.dosePerFraction || 0.0,
                'treatment_frequency': formState?.frequency || "",
                'field_name': formState?.fieldName || "",
                'field_size': formState?.fieldSize || "",
                'separation': formState?.separation || "",
                'depth': formState?.depth || "",
                'patient_position': formState?.patientPosition || "",
                'next_review_date': formState?.nextReviewDate ? DateTime.fromJSDate(new Date(formState?.nextReviewDate)).toFormat('yyyy-MM-dd') : null,
                'rt_tag_id': formState?.rtTag?.id || null,
                'status': "Pending",
                'credit_type': PatientData?.primary_payment_type || 'Patient credit',
                'company_name': PatientData?.corp_company_name || null,
                'employee_id': PatientData?.employee_id || null,
                'employer_id': PatientData?.employer_id || null,
                'insurance_company_name': PatientData?.insurance_company_name || null,
                'policy_no': PatientData?.policy_no || null,
                'sub_total_amount': +formState?.package?.package_amount || 0,
                'package_amount': formState?.package?.package_amount ? +((parseFloat(formState?.package?.package_amount) || 0) - (parseFloat(formState?.discountAmount) || 0)).toFixed(2) : 0,
                'discount_percentage': +formState?.discountPercentage || 0,
                'discount_amount': +formState?.discountAmount || 0,
                'discount_comments': formState?.discountComments || "",
            }
            if (radioTherapyId) {
                data["patient_radiotherapy_id"] = radioTherapyId
            } else {
                data["therapy_status"] = "Transmitted"
            }

            if (ForApproval) {
                data["request_status"] = "Requested"
                data["approver_id"] = selectedApprover?.login_user_id
            }else{
                data["request_status"] = ""
            }

            RestAPIService.create(data, (ForApproval ? Serviceurls.RT_DOCTOR_TRANSMIT_APPROVAL : Serviceurls.RT_DOCTOR_TRANSMIT))
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        GetTherapyDetails(PatientData?.patient_id)
                        clearFunction()
                        setAccordionOpen(false)
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const postDoctorDetails = (Status) => {
        try {
            let data = {
                'patient_radiotherapy_id': therapyPatientDetails?.id || null,
                'doctor_notes': formState?.DoctorNotes || "",
                'status': Status
            }
            setisloader(true)
            RestAPIService.updateWithOutId(data, Serviceurls.RT_DOCTORS_APPROVAL_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        clearFunction()
                        history.push({ pathname: '/DoctorHome', states: { FromRTApproval: true } })
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const postSessionUpdate = (dateChanged = false) => {
        try {
            let data = {
                'session_id': editSession?.id || null,
                'dose_per_fraction': +editSession?.dose_per_fraction || 0,
            }
            if (dateChanged) {
                data["session_date"] = editSession?.session_date ? DateTime.fromJSDate(new Date(editSession?.session_date)).toFormat('yyyy-MM-dd') : null
            }
            setisloader(true)
            RestAPIService.updateWithOutId(data, Serviceurls.RT_DOCTOR_TRANSMIT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        setEditSession(null)
                        setEditSessioncfPop(false)
                        GetTherapyDetails(PatientData?.patient_id)
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const postTherapyUpdate = (status) => {
        try {
            let data = {
                'status': status,
                'patient_radiotherapy_id': cancelTherapyId,
            }
            setisloader(true)
            RestAPIService.updateWithOutId(data, Serviceurls.RT_DOCTOR_UPDATE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        setEditSession(null)
                        setEditSessioncfPop(false)
                        setCancelTherapy(null)
                        setCancelTherapyId(null)
                        GetTherapyDetails(PatientData?.patient_id)
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const postDosimetrist = () => {
        try {
            const formData = new FormData();

            formData.append('patient_id', therapyPatientDetails?.patient_id || "");
            formData.append('branch_id', localGetItem("BranchId"));
            formData.append('doctor_id', therapyPatientDetails?.doctor_id || "");
            formData.append('therapy_id', formState?.therapy?.id || "");
            formData.append('technique_id', formState?.technique?.id || "");
            // formData.append('package_id', formState?.package?.id || "");
            formData.append('package_id', 82);
            formData.append('treatment_region_id', formState?.treatmentRegion?.id || "");
            formData.append('immobilization_device_id', formState?.immobilizationDevice?.id || "");
            formData.append('simulator_id', formState?.machine?.id || "");
            formData.append('radiation_type', formState?.radiationType || "");
            formData.append(
                'start_date',
                formState?.startDate
                    ? DateTime.fromJSDate(new Date(formState?.startDate)).toFormat('yyyy-MM-dd')
                    : ""
            );
            formData.append('total_dose', formState?.totalDose || 0);
            formData.append('number_of_fractions', formState?.fractions || 0);
            formData.append('dose_per_fraction', formState?.dosePerFraction || 0.0);
            formData.append('treatment_frequency', formState?.frequency || "");
            formData.append('field_name', formState?.fieldName || "");
            formData.append('field_size', formState?.totalDose || "");
            formData.append('separation', formState?.separation || "");
            formData.append('depth', formState?.depth || "");
            formData.append('patient_position', formState?.patientPosition || "");
            formData.append(
                'next_review_date',
                formState?.nextReviewDate
                    ? DateTime.fromJSDate(new Date(formState?.nextReviewDate)).toFormat('yyyy-MM-dd')
                    : ""
            );
            formData.append('rt_tag_id', formState?.rtTag?.id || "");
            formData.append('patient_radiotherapy_id', therapyPatientDetails?.id || "");
            formData.append('dosimetrist_notes', formState?.dosimetristNotes || "");
            formData.append('time', new Date().toISOString());
            if (Attachment?.imageuploadList?.length) {
                Attachment.imageuploadList.forEach((file, index) => {
                    formData.append('doc_key', file); // backend should handle array input
                });
            }
            setisloader(true)
            RestAPIService.create(formData, Serviceurls.RT_DOSIMETRIST_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        history.push({ pathname: '/RadiotherapyDosimetrist' })
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
            // }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const UploadButton = (onClick, imgSrc, text) => {
        return (
            <Button sx={{ textTransform: "capitalize" }}
                disabled={Attachment.imageuploadList?.length === 6}
                onClick={onClick}
            >
                <Box
                    component="div"
                    borderRadius="10px"
                    border="1px dotted gray"
                    height="7vw"
                    width="11vw"
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Box component="img" src={imgSrc} height="2vw" width="2vw" />
                    <Typography fontSize="0.9vw" color={Colors.SecondaryText} fontWeight={600} mt="0.5vw">
                        {Attachment.imageuploadList.length === 6 ? ("MaxUpload") : text}
                    </Typography>
                </Box>
            </Button>
        );
    };

    const isValidDay = (myDate, validDays) => {
        // Convert to Date object
        const date = new Date(myDate);

        // Get day index (0 = Sunday, ..., 6 = Saturday)
        const dayIndex = date.getDay();

        // Map to weekday names
        const daysMap = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

        // Expand validDays string into range
        let [startDay, , endDay] = validDays.split(" ");
        const startIndex = daysMap.indexOf(startDay);
        const endIndex = daysMap.indexOf(endDay);

        let isValid = false;

        if (startIndex !== -1 && endIndex !== -1) {
            if (startIndex <= endIndex) {
                isValid = dayIndex >= startIndex && dayIndex <= endIndex;
            } else {
                // Case like "Friday to Monday"
                isValid = dayIndex >= startIndex || dayIndex <= endIndex;
            }
        }

        return isValid
    }


    return (
        <Box sx={{ backgroundColor: Colors.Background, p: "0.3vw" }}>
            {forDocApproval ?
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton size="small" onClick={() => {
                        history.push({ pathname: '/DoctorHome', states: { FromRTApproval: true } })
                    }} >
                        <img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton.default} alt={"Back"} />
                    </IconButton>
                    <Typography sx={{ color: "#616161" }}> {"Back to Doctor Home"}</Typography></Stack> : null}
            {FromDosimetrist ?
                <Stack direction="row" spacing={1} alignItems="center">
                    <IconButton size="small" onClick={() => {
                        history.push({ pathname: '/RadiotherapyDosimetrist' })
                    }} >
                        <img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton.default} alt={"Back"} />
                    </IconButton>
                    <Typography sx={{ color: "#616161" }}> {"Back to Dosimetrist Home"}</Typography></Stack> : null}
            <Box display={'flex'}>
                <Box className='doc_header_card' mr={'0.5vw'}>
                    <CommonPatientDetails data={therapyPatientDetails ? therapyPatientDetails : PatientData} showDetailed={forDocAdd} />
                </Box>
            </Box>
            <Box sx={{ height: "69dvh", overflow: 'auto', marginTop: "0.5vw" }}>
                <Accordion expanded={forDocApproval || FromDosimetrist || accordionOpen} sx={{ marginTop: "0.5vw" }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} onClick={() => {
                        if (therapyDetails?.some((item) => (item?.status === "Pending" || item?.status === "Approved")) && accordionOpen === false) {
                            errorMessage("This patient already has one therapy pending, so a new one cannot be added")
                        } else {
                            setAccordionOpen(!accordionOpen)
                            clearFunction()
                        }
                    }}>
                        <Typography fontSize={'0.9rem'} fontWeight={600}>Radiotherapy</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box
                            sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "0.5vw", mt: "0.5vw", mb: "0.3vw" }}
                        >
                            {RenderTextField({ name: "therapy", label: `Select Therapy ${forDocAdd ? "*" : ""}`, options: TherapyMaster, getOptionLabel: (o) => o?.therapy_name || o, disable: (FromDosimetrist || forDocApproval || (therapyDetails.session_status !== "Pending" && therapyDetails.session_status)), maxlength: 100 })}
                            {RenderTextField({ name: "technique", label: `Select Technique ${forDocAdd ? "*" : ""}`, options: TherapyTecniques, getOptionLabel: (o) => o?.therapy_technique_name || o, disable: (FromDosimetrist || forDocApproval || (therapyDetails.session_status !== "Pending" && therapyDetails.session_status)), maxlength: 100 })}
                            {RenderTextField({ name: "package", label: `Select Package ${forDocAdd ? "*" : ""}`, options: packageDetails, getOptionLabel: (o) => `${o?.package_name} - ${AmountFormat(o?.package_amount || 0)}` || o, disable: (FromDosimetrist || forDocApproval || (therapyDetails.session_status !== "Pending" && therapyDetails.session_status)), maxlength: 100 })}
                            {RenderTextField({ name: "radiationType", label: "Select Radiation Type", options: ["EBRT", "Brachytherapy"], disable: (forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "treatmentRegion", label: "Treatment Region", options: TherapyRegions, getOptionLabel: (o) => o?.treatment_region_name || o, disable: (forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "immobilizationDevice", label: "Immobilization Device", options: TherapyImmuzationDevice, getOptionLabel: (o) => o?.immobilization_device_name || o, disable: (forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "startDate", label: `Start Date ${FromDosimetrist ? "*" : ""}`, type: "date", disable: (forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "totalDose", label: `Total Dose (Gy) ${FromDosimetrist ? "*" : ""}`, disable: (forDocApproval), maxlength: 5 })}
                            {RenderTextField({ name: "fractions", label: `Number of Fractions ${FromDosimetrist ? "*" : ""}`, disable: (forDocApproval), maxlength: 4 })}
                            {RenderTextField({ name: "frequency", label: `Treatment Frequency ${FromDosimetrist ? "*" : ""}`, options: ['Monday to Friday', 'Monday to Saturday'], disable: (forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "dosePerFraction", label: "Dose per Fraction (Gy)", disable: true, maxlength: 4 })}
                            {RenderTextField({ name: "fieldName", label: "Field Name", disable: (forDocAdd || forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "fieldSize", label: "Field Size", disable: (forDocAdd || forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "separation", label: "Separation", disable: (forDocAdd || forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "depth", label: "Depth", disable: (forDocAdd || forDocApproval), maxlength: 50 })}
                            {RenderTextField({ name: "patientPosition", label: "Patient Position", disable: (forDocAdd || forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "machine", label: "Select Machine", options: TherapyMachines, getOptionLabel: (o) => o?.stimulator_name || o, disable: (forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "nextReviewDate", label: "Next Review Date", type: "date", disable: (forDocApproval), maxlength: 100 })}
                            {RenderTextField({ name: "rtTag", label: "RT Tag", options: TherapyTag, getOptionLabel: (o) => o?.tag_name || o, disable: (forDocApproval), maxlength: 100 })}
                        </Box>
                        <Box>
                            <Divider textAlign='left' sx={{ marginLeft: '0.5vw' }}>
                                <Typography component={'p'} >Bill Details</Typography></Divider>
                            <Box sx={{ display: "flex", gap: "0.5vw", gridTemplateColumns: "repeat(4, 1fr)", gap: "0.5vw", mt: "0.5vw", mb: "0.3vw" }}>
                                {RenderTextField({ value: formState?.package?.package_amount || "", label: "Package Amount", disable: true, })}
                                <TextField
                                    size="small"
                                    label="Discount %"
                                    sx={{ width: "8vw" }}
                                    value={formState?.discountPercentage || ""}
                                    disabled={formState?.TherapyStatus === "Approved" || !formState?.package?.package_amount || FromDosimetrist || forDocApproval}
                                    onChange={(e) => {
                                        let percent = e.target.value;
                                        if (percent === "") {
                                            setFormState((prev) => ({ ...prev, discountPercentage: "", discountAmount: "", discountComments: "" }));
                                        } else {
                                            let isValid = CommonValidation.DecimalNumber(percent);
                                            let numericValue = Number(percent);
                                            if (isValid && numericValue >= 0 && numericValue <= 100) {
                                                const pkgAmt = parseFloat(formState?.package?.package_amount) || 0;
                                                const discAmt = Math.round((pkgAmt * numericValue) / 100);
                                                setFormState((prev) => ({ ...prev, discountPercentage: percent, discountAmount: discAmt }));
                                            }
                                        }
                                    }}
                                    inputProps={{ min: 0, max: 100 }}
                                />
                                <TextField
                                    size="small"
                                    label="Discount Amount"
                                    sx={{ width: "8vw" }}
                                    value={formState?.discountAmount || ""}
                                    disabled={formState?.TherapyStatus === "Approved" || !formState?.package?.package_amount || FromDosimetrist || forDocApproval}
                                    onChange={(e) => {
                                        let discAmt = e.target.value;
                                        if (discAmt === "") {
                                            setFormState((prev) => ({ ...prev, discountPercentage: "", discountAmount: "", discountComments: "" }));
                                        } else {
                                            let isValid = CommonValidation.numberOnly(discAmt);
                                            if (isValid) {
                                                let numericValue = parseInt(discAmt, 10) || 0; 
                                                const pkgAmt = parseFloat(formState?.package?.package_amount) || 0;
                                                if (numericValue < 0) numericValue = 0;
                                                if (numericValue > pkgAmt) numericValue = pkgAmt;
                                                const percent = pkgAmt > 0
                                                    ? ((numericValue / pkgAmt) * 100).toFixed(2)
                                                    : 0;
                                                setFormState((prev) => ({ ...prev, discountPercentage: percent, discountAmount: numericValue }));
                                            }
                                        }
                                    }}
                                    inputProps={{ min: 0 }}
                                /> 
                                <TextField
                                    size="small"
                                    label="Net Amount"
                                    type="number"
                                    value={
                                        formState?.package?.package_amount
                                            ? ((parseFloat(formState?.package?.package_amount) || 0) - (parseFloat(formState?.discountAmount) || 0)).toFixed(2)
                                            : ""
                                    }
                                    disabled={true}
                                />
                                <TextField
                                    size="small"
                                    sx={{ width: "31vw" }}
                                    label="Discount Comments"
                                    disabled={formState?.TherapyStatus === "Approved" || !formState?.package?.package_amount || FromDosimetrist || forDocApproval}
                                    value={formState?.discountComments || ""}
                                    onChange={(e) => { setFormState((prev) => ({ ...prev, discountComments: e.target.value })) }}
                                    inputProps={{ maxLength: 250 }}
                                    multiline
                                />
                                {!FromDosimetrist && !forDocApproval && (maxDocDiscount < formState?.discountPercentage) && formState?.discountPercentage ? <Autocomplete
                                    size='small'
                                    sx={{ width: '12dvw' }}
                                    disabled={formState?.TherapyStatus === "Approved" || !formState?.package?.package_amount || FromDosimetrist || forDocApproval}
                                    options={approverList}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.login_user_name}
                                    value={selectedApprover}
                                    onChange={(e, newValue) => {
                                        setSelectedApprover(newValue);
                                    }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        disabled={formState?.TherapyStatus === "Approved" || !formState?.package?.package_amount || FromDosimetrist || forDocApproval}
                                        InputProps={{ ...params.InputProps, emed_tid: 'req_name' }}
                                        label='Select Approver *'
                                    />}
                                /> : null}
                            </Box>
                        </Box>
                        {forDocApproval ?
                            <>
                                <TextField
                                    sx={{ width: "100%", marginTop: "0.5dvw" }}
                                    minRows={2}
                                    disabled
                                    label={"Dosimetrist Notes"}
                                    value={formState?.dosimetristNotes || ""}
                                    multiline />
                                <TextField
                                    sx={{ width: "100%", marginTop: "0.5dvw" }}
                                    minRows={2}
                                    disabled={therapyPatientDetails?.therapy_status !== "Waiting for Doctor Approval"}
                                    label={"Doctor Notes"}
                                    value={formState?.DoctorNotes || ""}
                                    inputProps={{ maxLength: 300 }}
                                    onChange={(e) => { setFormState((prev) => ({ ...prev, DoctorNotes: e.target.value })); }}
                                    multiline />
                            </> : null}
                        {FromDosimetrist ?
                            <Box>
                                {therapyPatientDetails?.doctor_notes ?
                                    <TextField
                                        sx={{ width: "100%", marginTop: "0.5dvw" }}
                                        minRows={2}
                                        disabled
                                        label={"Doctor Notes"}
                                        value={therapyPatientDetails?.doctor_notes || ""}
                                        multiline /> : null}
                                <TextField
                                    sx={{ width: "100%", marginTop: "0.5dvw" }}
                                    minRows={2}
                                    disabled={forDocApproval}
                                    label={"Dosimetrist Notes"}
                                    value={formState?.dosimetristNotes || ""}
                                    inputProps={{ maxLength: 300 }}
                                    onChange={(e) => { setFormState((prev) => ({ ...prev, dosimetristNotes: e.target.value })); }}
                                    multiline />
                            </Box> : null}
                        <Box display={formState?.AddedDocuments?.length ? "block" : "none"}>
                            <Button
                                sx={{ marginTop: "0.5vw", textTransform: "capitalize" }}
                                variant="contained"
                                size="small"
                                onClick={() => {
                                    if (formState?.AddedDocuments?.length > 0) {
                                        const imageFile = formState?.AddedDocuments || [];
                                        setAttachment(prev => ({
                                            ...prev,
                                            imageViewerPopup: true,
                                            viewOpen: true,
                                            viewData: [],
                                            viewImage: null
                                        }));

                                        renderImage(imageFile);
                                    } else {
                                        errorMessage('No Attachments to be view');
                                    }
                                }}>{`Show Added Attachments (${formState?.AddedDocuments?.length})`}</Button>
                        </Box>
                        <Box sx={{ marginTop: "0.75vw", overflow: "scroll", display: (forDocAdd || forDocApproval) ? "none" : "block" }}>
                            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                <Box component={'input'} type='file' sx={{ display: 'none' }}
                                    multiple
                                    accept="image/jpg, image/jpeg, image/png,application/pdf"
                                    ref={uploadImage}
                                    onChange={onImageHandler}
                                />
                                <Box>
                                    {UploadButton(() => {
                                        setAttachment((prev) => ({
                                            ...prev,
                                            imgCapClked: true,
                                        }));
                                    }, ImagePaths.CameraCapture.default, "Capture Attachment")}
                                    {UploadButton(() => uploadImage.current.click(), ImagePaths.LabUploadButton.default, "Browse Files")}
                                </Box>
                                {Attachment.imageuploadList?.length > 0 && (
                                    <Box
                                        component={'div'}
                                        display={'flex'}
                                        maxWidth={'62vw'}
                                        alignItems={'center'}
                                        overflow={'scroll'}
                                        marginLeft={'1vw'}
                                    >
                                        {Attachment.imageuploadList.map((image, index) => (
                                            <Box
                                                component={'div'}
                                                key={index}
                                                mr={'0.5vw'}
                                                height={'5vw'}
                                                display={'flex'}
                                                alignItems={'center'}
                                            >
                                                <Tooltip title={typeof image === 'string' ? '' : image?.name} arrow placement="top">
                                                    <Box
                                                        component={'img'}
                                                        onClick={() => {
                                                            if (typeof image === 'string') {
                                                                const ext = image.split('.').pop()?.toLowerCase();
                                                                if (['jpg', 'jpeg', 'png'].includes(ext)) {
                                                                    setAttachment((prev) => ({
                                                                        ...prev,
                                                                        isImgClicked: true,
                                                                        popUpOpen: true,
                                                                        selectedImage: image,
                                                                    }));
                                                                } else {
                                                                    window.open(image);
                                                                }
                                                            }
                                                        }}
                                                        src={
                                                            typeof image === 'string'
                                                                ? ['jpg', 'jpeg', 'png'].includes(image.split('.').pop()?.toLowerCase())
                                                                    ? image
                                                                    : ImagePaths.DocumentPreview.default
                                                                : image?.type === 'image/jpeg' || image?.type === 'image/png'
                                                                    ? ImagePaths.ImagePreview.default
                                                                    : ImagePaths.DocumentPreview.default
                                                        }
                                                        height={'4vw'}
                                                        width={'3.5vw'}
                                                    />
                                                </Tooltip>
                                                <Box>
                                                    <IconButton
                                                        sx={{ position: 'relative', bottom: '1.2vw', right: '1.4vw' }}
                                                        size="small"
                                                        onClick={() => {
                                                            setAttachment((prev) => ({
                                                                ...prev,
                                                                selectedImage: null,
                                                            }));
                                                            onImageRemove(index); // You must define `onImageRemove` in your functional component
                                                        }}
                                                    >
                                                        <CancelTwoToneIcon fontSize="small" color="error" />
                                                    </IconButton>
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                )}
                            </Box>

                        </Box>
                        {FromDosimetrist ?
                            <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "flex-end", marginTop: "1vw", visibility: props?.Access?.editAccess ? 'visible' : 'hidden' }}>
                                {/* <Button variant="outlined" size="small" sx={{ textTransform: "capitalize", marginRight: "1vw" }}>Clear</Button> */}
                                <Button disabled={isloader} variant="contained" size="small" sx={{ textTransform: "capitalize" }} onClick={() => {
                                    setisloader(true)
                                    if (!formState?.startDate) {
                                        errorMessage("Select the Start date")
                                    } else if (!formState?.totalDose) {
                                        errorMessage("Select the total Dose")
                                    } else if (!formState?.fractions) {
                                        errorMessage("Select number of fractions")
                                    } else if (!formState?.frequency) {
                                        errorMessage("Select the frequency")
                                    } else {
                                        postDosimetrist()
                                    }
                                }}>Submit to Approval</Button>
                            </Box>
                            :
                            forDocApproval ?
                                <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "flex-end", marginTop: "1vw" }}>
                                    <Button color="error" variant="contained" size="small"
                                        disabled={therapyPatientDetails?.therapy_status !== "Waiting for Doctor Approval"}
                                        sx={{ textTransform: "capitalize", marginRight: "1vw" }}
                                        onClick={() => {
                                            if (formState?.DoctorNotes) {
                                                postDoctorDetails("Rejected")
                                            } else {
                                                errorMessage("Enter the doctor notes for rejection")
                                            }
                                        }}>Reject</Button>
                                    <Button
                                        disabled={therapyPatientDetails?.therapy_status !== "Waiting for Doctor Approval"}
                                        variant="contained" size="small" sx={{ textTransform: "capitalize" }} onClick={() => {
                                            setisloader(true)
                                            if (!formState?.startDate) {
                                                errorMessage("Select the Start date")
                                            } else if (!formState?.totalDose) {
                                                errorMessage("Select the total Dose")
                                            } else if (!formState?.fractions) {
                                                errorMessage("Select number of fractions")
                                            } else if (!formState?.frequency) {
                                                errorMessage("Select the frequency")
                                            } else {
                                                postDoctorDetails("Approved")
                                            }
                                        }}>Approve</Button>
                                </Box>
                                :
                                <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "flex-end", marginTop: "1vw" }}>
                                    <Button disabled={radioTherapyId} variant="outlined" size="small" sx={{ textTransform: "capitalize", marginRight: "1vw" }} onClick={clearFunction}>Clear</Button>
                                    <Button disabled={isloader || formState?.TherapyStatus === "Approved"} variant="contained" size="small" sx={{ textTransform: "capitalize" }} onClick={() => {
                                        setisloader(true)
                                        if (!formState?.therapy) {
                                            errorMessage("Select Therapy")
                                        } else if (!formState?.technique) {
                                            errorMessage("Select Therapy Technique")
                                        } else if (!formState?.package) {
                                            errorMessage("Select Therapy Package")
                                        } else {
                                            if ((maxDocDiscount < formState?.discountPercentage) && formState?.discountPercentage && ((formState?.BillingDetails?.request_status === "Requested" || formState?.BillingDetails?.request_status === "" || !formState?.BillingDetails))) {
                                                if (!selectedApprover) {
                                                    errorMessage("Select an Approver")
                                                    setisloader(false)
                                                    return
                                                }
                                                postTransmitDetails(true)
                                            } else {
                                                postTransmitDetails()
                                            }
                                        } 
                                    }}>{!!formState?.discountPercentage && Number(formState?.discountPercentage) > Number(maxDocDiscount) ? "Sent for Discount Approval" : "Transmit"}</Button>
                                </Box>}

                    </AccordionDetails>
                </Accordion>
                {
                    (forDocApproval || FromDosimetrist) ? null :
                        <>
                            <Divider textAlign='left' sx={{ marginLeft: '0.5vw' }}>
                                <Typography sx={{ padding: "0.3vw", fontSize: '0.9vw', fontWeight: 600 }}>{"Therapy Details"}</Typography></Divider>
                            <Table size="small" sx={{ border: "1px solid #ddd", backgroundColor: 'white' }}>
                                <TableHead sx={{ background: "#f9f9f9" }}>
                                    <TableRow>
                                        <TableCell>Start Date</TableCell>
                                        <TableCell>Therapy Name</TableCell>
                                        <TableCell>Radiation Type</TableCell>
                                        <TableCell>Therapy Region</TableCell>
                                        <TableCell>Total Dose</TableCell>
                                        <TableCell>Fraction</TableCell>
                                        <TableCell>Dose /Fraction</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        therapyDetails?.length === 0 ?
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell>
                                                    <Typography sx={{ marginTop: "5vh" }}>No Records Found</Typography>
                                                </TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                            : therapyDetails?.map((row, index) => {
                                                let loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
                                                let isCancelledTherapy = (row?.status === "Stimulation Cancelled" || row?.status === "Cancelled" || row?.status === "Doctor Cancelled" || row?.status === "Dosimetrist Cancelled")
                                                let DisableTheray = (row?.status === "Completed" || isCancelledTherapy || (loggedInUserInfo?.module_name === "Doctor" && row?.doctor_id !== loggedInUserInfo?.doctor_id) || radioTherapyId)
                                                return (
                                                    <React.Fragment key={row.id}>
                                                        <TableRow>
                                                            <TableCell onClick={() => setExpandedRow(expandedRow === row.id ? null : row.id)}>{row.start_date ? formatDate(row.start_date) : "-"}</TableCell>
                                                            <TableCell onClick={() => setExpandedRow(expandedRow === row.id ? null : row.id)}>{ContentInTooltip((row?.therapy_name || "-"), 15)}</TableCell>
                                                            <TableCell onClick={() => setExpandedRow(expandedRow === row.id ? null : row.id)}>{ContentInTooltip((row?.radiation_type || "-"), 15)}</TableCell>
                                                            <TableCell onClick={() => setExpandedRow(expandedRow === row.id ? null : row.id)}>{ContentInTooltip((row?.region_name || "-"), 15)}</TableCell>
                                                            <TableCell onClick={() => setExpandedRow(expandedRow === row.id ? null : row.id)}>{row?.total_dose ? `${row?.total_dose} Gy` : "-"}</TableCell>
                                                            <TableCell onClick={() => setExpandedRow(expandedRow === row.id ? null : row.id)}>{row?.number_of_fractions || "-"}</TableCell>
                                                            <TableCell onClick={() => setExpandedRow(expandedRow === row.id ? null : row.id)}>{row?.dose_per_fraction ? `${row?.dose_per_fraction} Gy` : "-"}</TableCell>
                                                            <TableCell onClick={() => setExpandedRow(expandedRow === row.id ? null : row.id)}><Chip label={(row?.status === "Pending" && row?.billing_details?.request_status === "Requested") ? "Waiting for Approval" : row?.status} color={row?.status === "Completed" ? "success" : (isCancelledTherapy) ? "error" : "warning"} size="small" /></TableCell>
                                                            <TableCell align="left" sx={{ paddingX: 0 }}>
                                                                <Tooltip title="Edit Therapy" placement="top" arrow>
                                                                    <IconButton size="small" disabled={DisableTheray} onClick={() => {
                                                                        setFormState({
                                                                            therapy: TherapyMaster?.find((item) => (item?.id === row?.therapy_id)),
                                                                            technique: TherapyTecniques?.find((item) => (item?.id === row?.technique_id)),
                                                                            package: null,
                                                                            radiationType: row?.radiation_type,
                                                                            treatmentRegion: TherapyRegions?.find((item) => (item?.id === row?.treatment_region_id)),
                                                                            immobilizationDevice: TherapyImmuzationDevice?.find((item) => (item?.id === row?.immobilization_device_id)),
                                                                            startDate: row?.start_date || null,
                                                                            totalDose: row?.total_dose || "",
                                                                            fractions: row?.number_of_fractions || "",
                                                                            frequency: row?.treatment_frequency || "",
                                                                            dosePerFraction: row?.dose_per_fraction || "",
                                                                            fieldName: row?.field_name || "",
                                                                            fieldSize: row?.field_size || "",
                                                                            separation: row?.separation || "",
                                                                            depth: row?.depth || "",
                                                                            patientPosition: row?.patient_position || "",
                                                                            machine: TherapyMachines?.find((item) => (item?.id === row?.simulator_id)),
                                                                            nextReviewDate: row?.next_review_date || null,
                                                                            rtTag: TherapyTag?.find((item) => (item?.id === row?.rt_tag_id)),
                                                                            TherapyStatus: row?.status,
                                                                            BillingDetails: row?.billing_details || null,
                                                                            discountPercentage: row?.billing_details?.discount_percentage || "",
                                                                            discountAmount: row?.billing_details?.discount_amount || "",
                                                                            discountComments: row?.billing_details?.discount_comments || ""
                                                                        })
                                                                        setSelectedApprover(approverList?.find((item) => item?.login_user_id == row?.billing_details?.approver_id) || null)
                                                                        GetPackageDetails((TherapyMaster?.find((item) => (item?.id === row?.therapy_id))?.therapy_name), (TherapyTecniques?.find((item) => (item?.id === row?.technique_id))?.therapy_technique_name), row?.package_id)
                                                                        setRadiotherapyId(row?.id)
                                                                        setAccordionOpen(true)
                                                                    }}><Edit fontSize="small" color={DisableTheray ? "disabled" : "primary"} /></IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Complete Therapy" placement="top" arrow>
                                                                    <IconButton disabled={DisableTheray} size="small" onClick={() => {
                                                                        setCancelTherapy("complete")
                                                                        setCancelTherapyId(row?.id)
                                                                    }}><CheckCircle color={DisableTheray ? "disabled" : "primary"} /></IconButton>
                                                                </Tooltip>
                                                                <Tooltip title="Cancel Therapy" placement="top" arrow>
                                                                    <IconButton disabled={DisableTheray} size="small" onClick={() => {
                                                                        setCancelTherapy("cancel")
                                                                        setCancelTherapyId(row?.id)
                                                                    }}><CancelIcon color={DisableTheray ? "disabled" : "error"} /></IconButton>
                                                                </Tooltip>
                                                                <IconButton onClick={() => setExpandedRow(expandedRow === row.id ? null : row.id)}>
                                                                    {expandedRow === row.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                        < TableRow >
                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                                                                <Collapse in={expandedRow === row.id} timeout="auto" unmountOnExit>
                                                                    <Table size="small" style={{ marginBottom: "10px" }}>
                                                                        <TableHead style={{ backgroundColor: "#f5f5f5" }}>
                                                                            <TableRow>
                                                                                <TableCell>Date</TableCell>
                                                                                <TableCell>Dose</TableCell>
                                                                                <TableCell>Status</TableCell>
                                                                                <TableCell>Action</TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {row?.session_details && row?.session_details.map((item, i) => (
                                                                                <TableRow key={i}>
                                                                                    <TableCell>{
                                                                                        item?.id === editSession?.id ?
                                                                                            <Box>
                                                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                                    <DatePicker
                                                                                                        value={editSession?.session_date ? editSession?.session_date : null}
                                                                                                        name={"datePicker"}
                                                                                                        inputFormat='DD-MM-YYYY'
                                                                                                        views={["year", "month", "day"]}
                                                                                                        onChange={(newDate) => {
                                                                                                            setEditSession((prev) => ({
                                                                                                                ...prev,
                                                                                                                session_date: newDate,
                                                                                                            }));
                                                                                                        }}
                                                                                                        minDate={new Date()}
                                                                                                        renderInput={(dateparams) => <TextField
                                                                                                            {...dateparams}
                                                                                                            label={"Session Date"}
                                                                                                            variant="outlined"
                                                                                                            onKeyDown={(e) => e.preventDefault()}
                                                                                                            size='small'
                                                                                                        />}
                                                                                                    />
                                                                                                </LocalizationProvider>
                                                                                            </Box> :
                                                                                            item.session_date ? formatDate(item.session_date) : "-"}</TableCell>
                                                                                    <TableCell>{
                                                                                        item?.id === editSession?.id ?
                                                                                            <Box>
                                                                                                <TextField
                                                                                                    size="small"
                                                                                                    label={"Dose"}
                                                                                                    name={"sessionDose"}
                                                                                                    value={editSession?.dose_per_fraction || ""}
                                                                                                    onChange={(e) => {
                                                                                                        const val = e.target.value
                                                                                                        const regex = /^(\d{0,3})(\.(\d{0,2})?)?$/;
                                                                                                        if (val === '' || regex.test(val)) {
                                                                                                            setEditSession((prev) => ({
                                                                                                                ...prev,
                                                                                                                dose_per_fraction: e.target.value,
                                                                                                            }));
                                                                                                        }
                                                                                                    }}
                                                                                                    InputProps={{
                                                                                                        endAdornment: "Dy"
                                                                                                    }}
                                                                                                    inputProps={{ maxLength: 6 }}
                                                                                                />
                                                                                            </Box> :
                                                                                            item.dose_per_fraction ? `${item.dose_per_fraction} Gy` : "-"}</TableCell>
                                                                                    <TableCell>{item.session_status ? item.session_status : "-"}</TableCell>
                                                                                    <TableCell>{
                                                                                        item?.id === editSession?.id ?
                                                                                            <Box>
                                                                                                <Tooltip title={"Save Changes"} placement="top" arrow>
                                                                                                    <Button
                                                                                                        onClick={() => {
                                                                                                            if (!editSession?.session_date) {
                                                                                                                errorMessage("Selecet Session Start Date")
                                                                                                            } else if (!editSession?.dose_per_fraction) {
                                                                                                                errorMessage("Enter dose for this session")
                                                                                                            } else if (DateTime.fromJSDate(new Date(editSession?.session_date)).toFormat('yyyy-MM-dd') !== DateTime.fromJSDate(new Date(item?.session_date)).toFormat('yyyy-MM-dd')) {
                                                                                                                setEditSessioncfPop(true)
                                                                                                            } else {
                                                                                                                postSessionUpdate()
                                                                                                            }
                                                                                                        }}
                                                                                                        className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                                                                                        <img src={ImagePaths.TickEnable.default} alt="save changes" style={{ width: '1.5vw', height: '1.5vw' }} />
                                                                                                    </Button>
                                                                                                </Tooltip>
                                                                                                <Tooltip title={"Clear Changes"} placement="top" arrow>
                                                                                                    <Button
                                                                                                        onClick={() => { setEditSession(null) }}
                                                                                                        className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                                                                                        <img src={ImagePaths.RejectEnable.default} alt="save changes" style={{ width: '1.5vw', height: '1.5vw' }} />
                                                                                                    </Button>
                                                                                                </Tooltip>
                                                                                            </Box> :
                                                                                            <CommonEditButton disable={item.session_status !== "Pending" || DisableTheray} size="1.5vw" onClick={() => { setEditSession(structuredClone(item)) }} />
                                                                                    }
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                </Collapse>
                                                            </TableCell>
                                                        </TableRow>
                                                    </React.Fragment>
                                                )
                                            })}
                                </TableBody>
                            </Table>
                        </>}
            </Box>

            {/* Toast Messages */}
            {errorMsg && <ToastMsg severity={'error'} msg={errorMsgText} msgPop={msgClose} />}
            {successMsg && <ToastMsg severity={'success'} msg={successMsgText} msgPop={msgClose} />}
            {Attachment.imgCapClked && (
                <OpenWebCamPopUP
                    capturedImg={Attachment.CapturedImg}
                    closePopup={closeWebCamPop}
                    addImgCapture={addImgCapture}
                />
            )}
            <Dialog open={editSessionCfPop} >
                <DialogTitle id="eMed_MaxDialog_Title">{"Session Reschedule Confirmation"}</DialogTitle>
                <DialogContent sx={{ padding: "1dvw", width: '27dvw', display: 'flex', justifyContent: "center", flexDirection: 'column' }}>
                    <Paper
                        elevation={0}
                        sx={{
                            backgroundColor: '#F1F4FF',
                            border: '1px solid #0461B7',
                            borderRadius: '0.4vw',
                            padding: '1vw',
                            fontFamily: 'Roboto, sans-serif',
                            marginTop: "0.8vw"
                        }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                color: '#0461B7',
                                lineHeight: '1.5',
                                margin: 0,
                                fontWeight: 400
                            }}
                        >
                            Upcoming Session dates will be automatically updated based on the changed date
                        </Typography>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' size='small' className='eMed_Filter_Btns' onClick={() => {
                        setEditSessioncfPop(false)
                    }}>{"Close"}</Button>
                    <Button variant='contained' size='small' className='eMed_Filter_Btns' onClick={() => {
                        if (isValidDay((DateTime.fromJSDate(new Date(editSession?.session_date)).toFormat('yyyy-MM-dd')), editSession?.treatment_frequency)) {
                            postSessionUpdate(true)
                        } else {
                            errorMessage(`Invalid Date. Rescheduled date must be with in ${editSession?.treatment_frequency}`)
                        }
                    }}>{"Confirm"}</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={cancelTherapy !== null} >
                {/* <DialogTitle id="eMed_MaxDialog_Title">{"Alert !"}</DialogTitle> */}
                <DialogContent sx={{ padding: "1dvw", width: '25dvw', display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                    <Typography >{cancelTherapy === "complete" ? `Are You Sure? Do you want to complete this Therapy?` : `Are You Sure ? Do you want to cancel this therapy? If there any payments made, the refund request will generate to front office cashcounter.`}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color="error" size='small' className='eMed_Filter_Btns' onClick={() => {
                        setCancelTherapy(null)
                        setCancelTherapyId(null)
                    }}>{"Close"}</Button>
                    <Button variant='contained' color="error" size='small' className='eMed_Filter_Btns' onClick={() => {
                        if (cancelTherapy === "complete") {
                            postTherapyUpdate("Completed")
                        } else {
                            postTherapyUpdate("Cancelled")
                        }
                    }}>{"Confirm"}</Button>
                </DialogActions>
            </Dialog>
            {renderImageViewerPopup()}
            <Loader loaderOpen={isloader} />
        </Box>
    );
}
